import { HttpClient } from '@angular/common/http';
import { Injectable, InjectionToken, inject } from '@angular/core';

export type BaseConfig = {
  baseUrl: string;
  appName: string;
  flavor: 'vendors' | 'admins' | 'customers' | 'other';
  logo: string;
  logoHeight: string;
  loginTitle: string;
  loginSubtitle: string;
  shareBaseUrl: string;
  authRedirectUri: string;
};

export const BASE_CONFIG = new InjectionToken<BaseConfig>('BASE_CONFIG');

@Injectable({ providedIn: 'root' })
export class ApiService {
  http = inject(HttpClient);
  baseUrl = inject(BASE_CONFIG).baseUrl;
}
